import { Button, EmptyState } from "pixelize-design-library";
import { useNavigate } from "react-router";

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <EmptyState
      title="Page not found"
      description="That page does not exist in this store."
      action={<Button label="Back to home" onClick={() => void navigate("/")} />}
    />
  );
};
